<template>
	<div class="flex flex-col md:flex-row">
		<!-- product summary title
            ? to do: use component ? -->
		<div class="order-1 md:hidden space-y-2 px-4 pt-4 pb-0">
			<h1 class="flex items-baseline gap-x-4">
				<span class="text-4xl font-bold text-gray-700">{{
					$cropOptions.getLocalizedLabel(
						form.product.grade,
						$cropOptions.productGradeOptions
					)
				}}</span>
				<span class="text-xl text-gray-500 font-semibold">{{
					form.product.origin
				}}</span>
				<span class="text-xl text-gray-500 font-semibold">{{
					form.product.harvest
				}}</span>
			</h1>
			<div class="text-xl text-gray-500 font-semibold">
				{{ $cropOptions.dateToString(form, locale) }}
			</div>
		</div>

		<!-- left column -->
		<div
			class="order-3 md:order-2 md:w-2/3 divide-gray-200 divide-y overflow-y-auto"
		>
			<ui-alert-errors
				v-if="otherErrorMessages.length > 0"
				:messages="otherErrorMessages"
			/>

			<!-- product summary title
                ? to do: use component ? -->
			<div class="hidden md:block space-y-2 p-4">
				<h1 class="flex items-baseline gap-x-4">
					<span class="text-4xl font-bold text-gray-700">{{
						$cropOptions.getLocalizedLabel(
							form.product.grade,
							$cropOptions.productGradeOptions
						)
					}}</span>
					<span class="text-xl text-gray-500 font-semibold">{{
						form.product.origin
					}}</span>
					<span class="text-xl text-gray-500 font-semibold">{{
						form.product.harvest
					}}</span>
				</h1>
				<div class="text-xl text-gray-500 font-semibold">
					{{ $cropOptions.dateToString(form, locale) }}
				</div>
			</div>

			<bid-section label="Quality" :show-reference="showReference">
				<template v-slot:bid class="">
					<crop-quality-summary
						:tradable="form"
						ul-class="flex flex-wrap"
						li-class="w-1/2"
					/>
				</template>
				<!-- delete the following ??? -->
				<template v-slot:reference>
					<crop-quality-summary
						:tradable="reference"
						:reference-tradable="form"
					/>
				</template>
			</bid-section>

			<bid-section label="Location" :show-reference="showReference">
				<template v-slot:bid>
					{{ $cropOptions.locationToString(form, locale) }}
				</template>
				<template v-slot:reference>
					<!-- {{ $cropOptions.locationToString(reference, locale) }} -->
					{{
						$cropOptions.getLocalizedLabel(
							reference.location.mode,
							$cropOptions.locationModeOptions
						)
					}}
					<br />

					{{ reference.location.address.zip }}
					{{ reference.location.address.city }}
				</template>
			</bid-section>

			<bid-section label="Contract Conditions" :show-reference="showReference">
				<template v-slot:bid>
					<crop-extra-summary :tradable="form" />
				</template>
				<template v-slot:reference>
					<div class="hyphens">
						<crop-extra-summary :tradable="reference" />
					</div>
				</template>
			</bid-section>

			<div>
				<label
					data-v-0f0a6d18=""
					class="p-4 block font-medium text-gray-700 hyphens col-span-12 md:col-span-2"
				>
					{{ __("Validity") }}
				</label>
				<div data-v-0f0a6d18="" class="p-4">
					{{
						$cropOptions.getLocalizedLabel(
							form.extra.expiry_option,
							$cropOptions.bidExpiryOptions
						)
					}}
				</div>

				<!-- <ui-select-group
                    class="col-span-11 sm:col-span-6 md:col-start-9 md:col-end-13"
                    v-model="form.extra.expiry_option"
                    type="select"
                    field="extra.expiry_option"
                    label="Validity"
                    :options="$cropOptions.bidExpiryOptions.filter(o => !o.paperOnly === true)"
                    :form="form"
                    :required="true"
                    input-id="expiry-option"
                ></ui-select-group> -->
			</div>
		</div>

		<!-- right column -->
		<div class="order-2 md:order-3 md:w-1/3 p-4">
			<!-- product sell box
                ? to do: use component ? -->
			<div
				class="border border-gray-200 divide-y divide-gray-200 rounded-xl overflow-hidden"
			>
				<div class="bg-gray-700 px-4 py-2 text-white font-semibold">
					{{ __("Current cropspot daily price") }}
				</div>

				<!-- price -->
				<div class="px-4 pt-4 pb-6">
					<div class="price text-gray-700 font-bold">
						<span class="text-4xl">
							{{
								(1 * form.price.mt).toLocaleString(locale, {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2,
								})
							}}</span
						>
						<span class="font-semibold">€/t</span>
					</div>
					<p>{{ __("Flat Price") }}</p>
					<p>{{ $cropOptions.locationToString(form, locale) }}</p>
				</div>

				<!-- qty and button -->
				<div class="px-4 pt-4 pb-6">
					<ui-input-group
						class="text-xl mb-6"
						v-model="form.qty.mt"
						field="qty.mt"
						label="Quantity"
						suffix="t"
						:form="form"
						:required="true"
						:disabled="!reference.qty.partial_ok"
					></ui-input-group>

					<p v-if="!reference.qty.partial_ok" class="mb-4">
						{{ __("The buyer only accepts offers over the full quantity") }}
					</p>

					<ui-button
						class="text-xl mb-4 w-full"
						type="primary"
						v-on:click="$emit('tryGotoStepIfFormValid')"
						label="Offer quantity"
					/>

					<p>{{ __("You can check your offer in the next step") }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		counterpart: {
			type: Object,
			required: true,
		},
		reference: {
			type: Object,
			required: true,
		},
		match: {
			type: Object,
			required: false,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
		trade: {
			type: String,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		otherErrors: {
			type: Object,
			required: false,
		},
		showReference: {
			type: Boolean,
			default: true,
		},
		lastDisplayedPrice: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			// showReference: true,
		};
	},
	computed: {
		otherErrorMessages() {
			return Object.values(this.otherErrors || {});
		},
		priceGrid() {
			return {
				cols: "5",
				flat: {
					colSpan: [2],
				},
				indexed: {
					colSpan: [3, 2],
				},
			};
		},
	},
};
</script>

<style scoped>
.hyphens {
	-webkit-hyphens: auto;
	-ms-hyphens: auto;
	hyphens: auto;
}
</style>
